// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2407":"d8e72b4a","6473":"1ac6b9b4","8851":"2c91d4ad","9671":"8866f036"}[chunkId] + ".chunk.css";
};